import UntitledIcon, { TIconName } from '@payaca/untitled-icons';
import React, { FunctionComponent, type JSX } from 'react';
import './ClickableArea.sass';

export enum ClickableAreaColourVariant {
  SECONDARY_LIGHTER = 'secondary-lighter',
  SECONDARY_LIGHT = 'secondary-light',
}

type Props = {
  onClick?: () => void;
  className?: string;
  isProcessing?: boolean;
  colourVariant?: ClickableAreaColourVariant;
  isDisabled?: boolean;
  iconBefore?: TIconName | JSX.Element;
};

const ClickableArea: FunctionComponent<React.PropsWithChildren<Props>> = ({
  onClick,
  className,
  isProcessing,
  colourVariant = ClickableAreaColourVariant.SECONDARY_LIGHTER,
  children,
  isDisabled = false,
  iconBefore,
}: React.PropsWithChildren<Props>): JSX.Element => {
  return (
    <div
      className={`clickable-area ${className ? className : ''} ${
        isProcessing ? 'processing' : ''
      } area-col-${colourVariant} ${isDisabled ? 'disabled' : ''}`}
      role="button"
      onClick={!isDisabled ? onClick : undefined}
    >
      <div className="clickable-area-content">
        {iconBefore && (
          <span className="icon-container">
            {React.isValidElement(iconBefore) ? (
              iconBefore
            ) : (
              // @ts-expect-error
              <UntitledIcon name={iconBefore} />
            )}
          </span>
        )}
        <div>{children}</div>
      </div>
      {isProcessing && (
        <span className={'spinner-container'}>
          <UntitledIcon name="loading-01.3" className="animate-spin" />
        </span>
      )}
    </div>
  );
};

export default ClickableArea;
